import type { ProjectTemplateParameterResource, ProjectTemplateParameterSetResource, ProjectTemplateResource, VariableSetResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
export type ProducerProjectTemplateContextProps = {
    localNames: string[];
    parameters: ProjectTemplateParameterResource[];
    projectTemplate: ProjectTemplateResource;
    variables?: VariableSetResource;
};
export const ProducerProjectTemplateContext = React.createContext<ProducerProjectTemplateContextProps | undefined>(undefined);
export const useOptionalProducerProjectTemplateContext = () => {
    return React.useContext(ProducerProjectTemplateContext);
};
export function buildProducerProjectTemplateContextProps(resource: ProjectTemplateResource, parameterSet: ProjectTemplateParameterSetResource, variableSet?: VariableSetResource): ProducerProjectTemplateContextProps {
    const parameterNames = parameterSet.Parameters.toSorted((a, b) => a.Name.localeCompare(b.Name)).map((p) => p.Name);
    const variableNames = variableSet?.Variables?.map((v) => v.Name).toSorted((a, b) => a.localeCompare(b)) || [];
    const allLocalNames = variableNames.length > 0 ? [...parameterNames, ...variableNames].toSorted((a, b) => a.localeCompare(b)) : parameterNames;
    return {
        projectTemplate: resource,
        parameters: parameterSet.Parameters,
        variables: variableSet,
        localNames: allLocalNames,
    };
}
